import React, { useMemo, useState } from 'react';

import { string } from 'yup';

import { FormSection } from 'src/app/components/lib/form';
import { Input } from 'src/app/components/lib/input';
import { Modal } from 'src/app/components/lib/modal';

type SendTestSMSModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSendClick: (sendTo: string) => void;
};

const yupSMSSchema = string().required();

export function SendTestSMSModal({ onSendClick, isOpen, onClose }: SendTestSMSModalProps) {
  const [sendTo, setSendTo] = useState('');

  const isValidSMS = useMemo(() => yupSMSSchema.isValidSync(sendTo), [sendTo]);
  return (
    <Modal
      Content={
        <FormSection>
          <Input
            label='Send test SMS to:'
            labelPlacement='top'
            value={sendTo}
            onChange={(e) => setSendTo(e.target.value)}
          />
        </FormSection>
      }
      open={isOpen}
      primaryActions={[
        {
          label: 'Send',
          onClick: () => onSendClick(sendTo),
          disabled: !isValidSMS,
        },
      ]}
      title='Send preview'
      onClose={onClose}
    />
  );
}
